// import bcrypt from "bcryptjs"; //npm install bcryptjs



const mockUsers = [
  {
    username: "abhik123",
    FirstName: "Abhik",
    LastName: "Padhy",
    email: "abhik.padhy@gmail.com",
    // password: bcrypt.hashSync("password", 10), // Hashed password
    Gender: "Male",
    MobileNumber: "9845585426",
    DateOfBirth: "22/03/2014",
    Location: "Bangalore",
  },
];

// Mock signup function with validation
export const signup = async (userData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const existingUser = mockUsers.find(
        (u) =>
          u.username.toLowerCase() === userData.username.toLowerCase() ||
          u.email.toLowerCase() === userData.email.toLowerCase()
      );

      if (existingUser) {
        resolve({
          status: "error",
          message: "Username or email already in use.",
        });
      } else {
        const newUser = {
          ...userData,
          // password: bcrypt.hashSync(userData.password, 10), // Hash password
        };
        mockUsers.push(newUser);
        resolve({
          status: "success",
          message: "User registered successfully!",
          data: newUser,
        });
      }
    }, 1000);
  });
};

// Mock login function with case-insensitive match & password validation
export const login = async (userData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const user = mockUsers.find(
        (u) =>
          u.username.toLowerCase() === userData.userIdentifier.toLowerCase() ||
          u.email.toLowerCase() === userData.userIdentifier.toLowerCase() ||
          u.MobileNumber === userData.userIdentifier
      );

      if (!user) {
        resolve({
          status: "error",
          message: "Username, Email, or Mobile Number does not exist.",
        });
/*      } else if (!bcrypt.compareSync(userData.password, user.password)) {
        resolve({
          status: "error",
          message: "Incorrect password.",
        }); */ 
      } else {
        resolve({
          status: "success",
          message: "Login successful!",
          token: "mocked-token",
          user,
        });
      }
    }, 1000);
  });
};

const API_BASE_URL = "http://localhost:5000/comments";

// Fetch comments for a specific mediaId
export const fetchComments = async (mediaId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?mediaId=${mediaId}`);
    
    if (!response.ok) throw new Error("Failed to fetch comments");

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching comments:", error);
    return { comments: [] };
  }
};

// Add a new comment to the backend
export const addComment = async (mediaId, commentText) => {
  try {
    const response = await fetch(API_BASE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mediaId, comment: commentText.trim() }),
    });

    if (!response.ok) throw new Error("Failed to add comment");

    return await response.json();
  } catch (error) {
    console.error("Error adding comment:", error);
    return null;
  }
};
